import React, { useEffect, useState } from 'react'
import HomeBanner from './HomeBanner'
import AboutSection from './AboutSection'
import WhatWeDo from './WhatWeDo'
import CtaSection from './CtaSection'
import Line from "../../../assets/images/line.png"
import ChooseSection from './ChooseSection'
import Contact from './Contact'
import Pricing from '../../Reusable/Pricing'
import Testimonial from './Testimonial'
import Blog from './Blog'
import Partners from '../../common/Partners'
import { axiosInstance } from '../config'
import Loader from '../../common/Loader'
import { Helmet } from 'react-helmet'


const Index = () => {  

  const [data ,setdata] = useState([]);
  const [loading,setLoading] = useState([]);
  useEffect(() => {
    getData();
  },[])


  const getData = () => {
      setLoading(true)
      axiosInstance.get(`settings`)
          .then(res => {
              setdata(res?.data?.settings)
          })
          .catch((err) => console.log(err))
          .finally(() => {
              setLoading(false)
          })
  }

  return (
    <div className='main-content'>
      <Helmet>
        <title>{data[0]?.metatitle || "Precision Contract Cleaning"}</title>
        <meta name="description" content={data[0]?.metadescription || "Precision Contract Cleaning"} />
        <meta name="keywords" content={data[0]?.metakeywords || "Precision Contract Cleaning"} />
      </Helmet>
      {loading && <Loader/>}
      <HomeBanner  data={data}/>
      <AboutSection data={data}/>
      <WhatWeDo />
      <CtaSection Line={Line} />
      <ChooseSection Line={Line} />
      <Contact />
      {/* <Pricing Line={Line} /> */}
      <Testimonial />
      <Blog Line={Line} />
      <Partners />
    </div>
  )
}

export default Index
